import React from 'react';

import SecondaryButton from 'components/buttons/SecondaryButton';

import { BUSINESS_PATH } from 'routes';
import { Text, Wrapper } from 'components/CTAStyles';

// TODO: Add to contentful and retrieve from the API
const CTA = () => (
  <Wrapper>
    <Text>Upskill your teams in data science and analytics</Text>
    <SecondaryButton href={BUSINESS_PATH}>Learn More</SecondaryButton>
  </Wrapper>
);

export default CTA;
